module.exports = __webpack_public_path__ + "dist/img/v-api@512.2c70ebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v-api@512.png
// module id = 16
// module chunks = 0